const CONSENT_KEY = 'gc_cookie_consent';

export function readConsent() {
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : 'unset';
  } catch {
    return 'unset';
  }
}

export function writeConsent(value: 'accepted' | 'rejected') {
  window.localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(
    new CustomEvent('gc-consent-changed', { detail: { value } }),
  );
}

function bannerMarkup() {
  return `<aside id="gc-cookie-banner" style="position:fixed;left:12px;right:12px;bottom:12px;z-index:9999;max-width:640px;margin:0 auto;background:rgba(252,250,246,0.98);border:1px solid #d8cbbc;border-radius:18px;box-shadow:0 18px 44px rgba(73,53,33,0.12);padding:14px 14px 12px;color:#2a2018;font:13px/1.45 Arial,sans-serif;backdrop-filter:blur(14px);">
    <div style="display:flex;flex-direction:column;gap:12px;">
      <div style="display:flex;flex-direction:column;gap:4px;min-width:0;">
        <strong style="display:block;font-size:14px;line-height:1.3;">Analytics preferences</strong>
        <span>Allow optional analytics so we can improve the site. We never use this to track your child's handbook answers. <a href="/privacy.html" style="color:#4d6b57;text-decoration:none;font-weight:700;white-space:nowrap;">Privacy</a></span>
      </div>
      <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
        <button type="button" data-consent="rejected" style="flex:1 1 140px;min-height:42px;border:1px solid #bbaea0;background:#fff;color:#2a2018;border-radius:999px;padding:10px 14px;font:700 13px Arial,sans-serif;cursor:pointer;">No thanks</button>
        <button type="button" data-consent="accepted" style="flex:1 1 180px;min-height:42px;border:0;background:#4d6b57;color:#fff;border-radius:999px;padding:10px 16px;font:700 13px Arial,sans-serif;cursor:pointer;">Allow analytics</button>
      </div>
    </div>
  </aside>`;
}

export function mountConsentBanner() {
  if (typeof document === 'undefined' || readConsent() !== 'unset') return;
  if (document.getElementById('gc-cookie-banner')) return;
  document.body.insertAdjacentHTML('beforeend', bannerMarkup());
  const banner = document.getElementById('gc-cookie-banner');
  banner?.addEventListener('click', (event) => {
    const target =
      event.target instanceof HTMLElement
        ? event.target.closest('[data-consent]')
        : null;
    const value = target?.getAttribute('data-consent');
    if (value === 'accepted' || value === 'rejected') {
      writeConsent(value);
      banner.remove();
    }
  });
}
